var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { Toast } from 'primereact/toast';
import { Tag } from 'primereact/tag';
import { confirmDialog } from 'primereact/confirmdialog';
import { apiService } from '../utils/api';
import { formatINR } from '../utils/currencyUtils';
import { formatDateForUI } from '../utils/dateUtils';
import MdlPaginatorLeft from '../components/MdlPaginatorLeft';
import '../styles/masterListView.css';
import { pillValue } from '../utils/mdlPill';
var paymentModes = [
    { label: 'Cash', value: 'CASH' },
    { label: 'Bank Transfer', value: 'BANK_TRANSFER' },
    { label: 'UPI', value: 'UPI' },
    { label: 'Cheque', value: 'CHEQUE' },
];
var statusOptions = [
    { label: 'Draft', value: 'DRAFT' },
    { label: 'Approved', value: 'APPROVED' },
    { label: 'Rejected', value: 'REJECTED' },
];
var statusColors = {
    DRAFT: 'warning', APPROVED: 'success', REJECTED: 'danger'
};
var Expenses = function () {
    var _a = useState([]), expenses = _a[0], setExpenses = _a[1];
    var _b = useState([]), categories = _b[0], setCategories = _b[1];
    var _c = useState([]), paymentAccounts = _c[0], setPaymentAccounts = _c[1];
    var _d = useState(false), dialogVisible = _d[0], setDialogVisible = _d[1];
    var _e = useState(false), loading = _e[0], setLoading = _e[1];
    var _f = useState(null), filterStatus = _f[0], setFilterStatus = _f[1];
    var _g = useState(null), categoryFilter = _g[0], setCategoryFilter = _g[1];
    var _h = useState(''), searchInput = _h[0], setSearchInput = _h[1];
    var _j = useState(''), globalFilter = _j[0], setGlobalFilter = _j[1];
    var _k = useState(0), first = _k[0], setFirst = _k[1];
    var _l = useState(25), rows = _l[0], setRows = _l[1];
    var _m = useState({
        expenseDate: new Date(),
        categoryId: null,
        paymentAccountId: null,
        amount: 0,
        paidTo: '',
        paymentMode: 'CASH',
        chequeNumber: '',
        referenceNumber: '',
        narration: ''
    }), newExpense = _m[0], setNewExpense = _m[1];
    var toast = useRef(null);
    useEffect(function () {
        fetchExpenses();
        fetchCategories();
        fetchPaymentAccounts();
    }, []);
    useEffect(function () {
        var debounce = setTimeout(function () { return setGlobalFilter(searchInput); }, 300);
        return function () { return clearTimeout(debounce); };
    }, [searchInput]);
    useEffect(function () {
        setFirst(0);
    }, [globalFilter, filterStatus, categoryFilter]);
    var fetchExpenses = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setLoading(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiService.get('/expenses')];
                case 2:
                    response = _b.sent();
                    if (response.success)
                        setExpenses(response.data || []);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _b.sent();
                    (_a = toast.current) === null || _a === void 0 ? void 0 : _a.show({ severity: 'error', summary: 'Error', detail: 'Failed to fetch expenses' });
                    return [3 /*break*/, 4];
                case 4:
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var fetchCategories = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, apiService.get('/expenses/categories')];
                case 1:
                    response = _a.sent();
                    if (response.success)
                        setCategories(response.data || []);
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _a.sent();
                    console.error('Failed to fetch categories');
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var fetchPaymentAccounts = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, cashBank, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, apiService.get('/accounts/type/ASSET')];
                case 1:
                    response = _a.sent();
                    if (response.success && response.data) {
                        cashBank = response.data.filter(function (a) { return a.accountCode.startsWith('10'); });
                        setPaymentAccounts(cashBank);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_3 = _a.sent();
                    console.error('Failed to fetch accounts');
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var payload, response, error_4;
        var _a, _b, _c, _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    if (!newExpense.categoryId) {
                        (_a = toast.current) === null || _a === void 0 ? void 0 : _a.show({ severity: 'error', summary: 'Validation', detail: 'Category is required' });
                        return [2 /*return*/];
                    }
                    if (!newExpense.paymentAccountId) {
                        (_b = toast.current) === null || _b === void 0 ? void 0 : _b.show({ severity: 'error', summary: 'Validation', detail: 'Payment account is required' });
                        return [2 /*return*/];
                    }
                    if (!newExpense.amount || newExpense.amount <= 0) {
                        (_c = toast.current) === null || _c === void 0 ? void 0 : _c.show({ severity: 'error', summary: 'Validation', detail: 'Amount must be greater than 0' });
                        return [2 /*return*/];
                    }
                    _g.label = 1;
                case 1:
                    _g.trys.push([1, 3, , 4]);
                    payload = __assign(__assign({}, newExpense), { expenseDate: newExpense.expenseDate instanceof Date
                            ? newExpense.expenseDate.toISOString().split('T')[0]
                            : newExpense.expenseDate });
                    return [4 /*yield*/, apiService.post('/expenses', payload)];
                case 2:
                    response = _g.sent();
                    if (response.success) {
                        (_d = toast.current) === null || _d === void 0 ? void 0 : _d.show({ severity: 'success', summary: 'Success', detail: 'Expense created' });
                        setDialogVisible(false);
                        resetForm();
                        fetchExpenses();
                    }
                    else {
                        (_e = toast.current) === null || _e === void 0 ? void 0 : _e.show({ severity: 'error', summary: 'Error', detail: response.error || 'Failed to create' });
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_4 = _g.sent();
                    (_f = toast.current) === null || _f === void 0 ? void 0 : _f.show({ severity: 'error', summary: 'Error', detail: 'Failed to create expense' });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleApprove = function (expense) {
        confirmDialog({
            message: "Approve expense \"".concat(expense.narration || expense.category.name, "\" for ").concat(formatINR(expense.amount, true), "?"),
            header: 'Confirm Approval',
            icon: 'pi pi-check',
            accept: function () { return __awaiter(void 0, void 0, void 0, function () {
                var response, error_5;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            _d.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, apiService.put("/expenses/".concat(expense.id, "/approve"), {})];
                        case 1:
                            response = _d.sent();
                            if (response.success) {
                                (_a = toast.current) === null || _a === void 0 ? void 0 : _a.show({ severity: 'success', summary: 'Approved', detail: 'Expense approved & journal entry created' });
                                fetchExpenses();
                            }
                            else {
                                (_b = toast.current) === null || _b === void 0 ? void 0 : _b.show({ severity: 'error', summary: 'Error', detail: response.error || 'Failed to approve' });
                            }
                            return [3 /*break*/, 3];
                        case 2:
                            error_5 = _d.sent();
                            (_c = toast.current) === null || _c === void 0 ? void 0 : _c.show({ severity: 'error', summary: 'Error', detail: 'Failed to approve expense' });
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            }); }
        });
    };
    var handleReject = function (expense) {
        confirmDialog({
            message: "Reject expense \"".concat(expense.narration || expense.category.name, "\"?"),
            header: 'Confirm Rejection',
            icon: 'pi pi-times',
            accept: function () { return __awaiter(void 0, void 0, void 0, function () {
                var response, error_6;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            _d.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, apiService.put("/expenses/".concat(expense.id, "/reject"), {})];
                        case 1:
                            response = _d.sent();
                            if (response.success) {
                                (_a = toast.current) === null || _a === void 0 ? void 0 : _a.show({ severity: 'success', summary: 'Rejected', detail: 'Expense rejected' });
                                fetchExpenses();
                            }
                            else {
                                (_b = toast.current) === null || _b === void 0 ? void 0 : _b.show({ severity: 'error', summary: 'Error', detail: response.error || 'Failed to reject' });
                            }
                            return [3 /*break*/, 3];
                        case 2:
                            error_6 = _d.sent();
                            (_c = toast.current) === null || _c === void 0 ? void 0 : _c.show({ severity: 'error', summary: 'Error', detail: 'Failed to reject expense' });
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            }); }
        });
    };
    var handleDelete = function (expense) {
        confirmDialog({
            message: "Delete expense \"".concat(expense.narration || expense.category.name, "\"?"),
            header: 'Confirm Delete',
            icon: 'pi pi-exclamation-triangle',
            accept: function () { return __awaiter(void 0, void 0, void 0, function () {
                var response, error_7;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            _d.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, apiService.delete("/expenses/".concat(expense.id))];
                        case 1:
                            response = _d.sent();
                            if (response.success) {
                                (_a = toast.current) === null || _a === void 0 ? void 0 : _a.show({ severity: 'success', summary: 'Deleted', detail: 'Expense deleted' });
                                fetchExpenses();
                            }
                            else {
                                (_b = toast.current) === null || _b === void 0 ? void 0 : _b.show({ severity: 'error', summary: 'Error', detail: response.error || 'Failed to delete' });
                            }
                            return [3 /*break*/, 3];
                        case 2:
                            error_7 = _d.sent();
                            (_c = toast.current) === null || _c === void 0 ? void 0 : _c.show({ severity: 'error', summary: 'Error', detail: 'Failed to delete expense' });
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            }); }
        });
    };
    var resetForm = function () {
        setNewExpense({
            expenseDate: new Date(), categoryId: null, paymentAccountId: null,
            amount: 0, paidTo: '', paymentMode: 'CASH', chequeNumber: '', referenceNumber: '', narration: ''
        });
    };
    var term = globalFilter.trim().toLowerCase();
    var filteredExpenses = expenses.filter(function (e) {
        var _a, _b;
        return (!filterStatus || e.status === filterStatus) &&
            (!categoryFilter || ((_a = e.category) === null || _a === void 0 ? void 0 : _a.id) === categoryFilter) &&
            (!term || [(_b = e.category) === null || _b === void 0 ? void 0 : _b.name, e.paidTo, e.narration, e.referenceNumber, e.chequeNumber]
                .some(function (v) { return v === null || v === void 0 ? void 0 : v.toLowerCase().includes(term); }));
    });
    var hasFilters = !!(globalFilter || filterStatus || categoryFilter);
    var categoryFilterOptions = categories.map(function (c) { return ({ label: c.name, value: c.id }); });
    var categoryOptions = categories.map(function (c) { return ({ label: "".concat(c.name, " (").concat(c.account.accountCode, ")"), value: c.id }); });
    var paymentAccountOptions = paymentAccounts.map(function (a) { return ({ label: "".concat(a.accountCode, " - ").concat(a.accountName), value: a.id }); });
    var dateTemplate = function (row) { return formatDateForUI(row.expenseDate); };
    var amountTemplate = function (row) { return _jsx("span", __assign({ style: { fontWeight: 600 } }, { children: formatINR(row.amount, true) })); };
    var statusTemplate = function (row) { return _jsx(Tag, { value: row.status, severity: statusColors[row.status] }); };
    var actionTemplate = function (row) { return (_jsx("div", __assign({ className: "mdl-action-group" }, { children: row.status === 'DRAFT' && (_jsxs(_Fragment, { children: [_jsx("button", __assign({ type: "button", className: "mdl-icon-btn success", onClick: function () { return handleApprove(row); }, "aria-label": "Approve expense", title: "Approve" }, { children: _jsx("i", { className: "pi pi-check" }) })), _jsx("button", __assign({ type: "button", className: "mdl-icon-btn", onClick: function () { return handleReject(row); }, "aria-label": "Reject expense", title: "Reject" }, { children: _jsx("i", { className: "pi pi-times" }) })), _jsx("button", __assign({ type: "button", className: "mdl-icon-btn danger", onClick: function () { return handleDelete(row); }, "aria-label": "Delete expense", title: "Delete" }, { children: _jsx("i", { className: "pi pi-trash" }) }))] })) }))); };
    // Summary
    var totalApproved = expenses.filter(function (e) { return e.status === 'APPROVED'; }).reduce(function (sum, e) { return sum + e.amount; }, 0);
    var totalPending = expenses.filter(function (e) { return e.status === 'DRAFT'; }).reduce(function (sum, e) { return sum + e.amount; }, 0);
    var pendingCount = expenses.filter(function (e) { return e.status === 'DRAFT'; }).length;
    return (_jsxs("div", __assign({ className: "card mdl-page" }, { children: [_jsx(Toast, { ref: toast }), _jsxs("div", __assign({ className: "mdl-page-header" }, { children: [_jsxs("div", { children: [_jsx("h1", __assign({ className: "mdl-page-title" }, { children: "Expense Management" })), _jsxs("p", __assign({ className: "mdl-page-subtitle" }, { children: [expenses.length, " entr", expenses.length === 1 ? 'y' : 'ies'] }))] }), _jsx("div", __assign({ className: "mdl-page-actions" }, { children: _jsx(Button, { label: "New Expense", icon: "pi pi-plus", className: "mdl-btn-primary", onClick: function () { resetForm(); setDialogVisible(true); } }) }))] })), _jsxs("div", __assign({ className: "mdl-stat-row" }, { children: [_jsxs("div", __assign({ className: "mdl-stat success" }, { children: [_jsx("div", __assign({ className: "mdl-stat-label" }, { children: "Total Approved" })), _jsx("div", __assign({ className: "mdl-stat-value" }, { children: formatINR(totalApproved, true) }))] })), _jsxs("div", __assign({ className: "mdl-stat warning" }, { children: [_jsx("div", __assign({ className: "mdl-stat-label" }, { children: "Pending Approval" })), _jsx("div", __assign({ className: "mdl-stat-value" }, { children: formatINR(totalPending, true) })), _jsxs("div", __assign({ className: "mdl-stat-note" }, { children: [pendingCount, " entries"] }))] })), _jsxs("div", __assign({ className: "mdl-stat" }, { children: [_jsx("div", __assign({ className: "mdl-stat-label" }, { children: "Total Entries" })), _jsx("div", __assign({ className: "mdl-stat-value" }, { children: expenses.length }))] }))] })), _jsxs("div", __assign({ className: "mdl-toolbar" }, { children: [_jsxs("span", __assign({ className: "p-input-icon-left mdl-search" }, { children: [_jsx("i", { className: "pi pi-search" }), _jsx(InputText, { placeholder: "Search category, paid to or narration", value: searchInput, onChange: function (e) { return setSearchInput(e.target.value); }, className: "mdl-search-input" })] })), _jsxs("div", __assign({ className: "mdl-toolbar-filters" }, { children: [_jsx(Dropdown, { value: categoryFilter, options: categoryFilterOptions, onChange: function (e) { return setCategoryFilter(e.value); }, placeholder: "Category: All", valueTemplate: pillValue('Category'), showClear: true, filter: true, className: "mdl-filter-pill".concat(categoryFilter ? ' applied' : '') }), _jsx(Dropdown, { value: filterStatus, options: statusOptions, onChange: function (e) { return setFilterStatus(e.value); }, placeholder: "Status: All", valueTemplate: pillValue('Status'), showClear: true, className: "mdl-filter-pill".concat(filterStatus ? ' applied' : '') })] }))] })), _jsxs(DataTable, __assign({ value: filteredExpenses, loading: loading, paginator: true, first: first, rows: rows, onPage: function (e) { setFirst(e.first); setRows(e.rows); }, sortField: "expenseDate", sortOrder: -1, className: "p-datatable-sm mdl-table-header mdl-table-footer", paginatorLeft: _jsx(MdlPaginatorLeft, { id: "expenses-rows-per-page", first: first, rows: rows, total: filteredExpenses.length, options: [25, 50, 100], onRowsChange: function (r) { setRows(r); setFirst(0); } }), paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink", emptyMessage: hasFilters ? 'No expenses match your filters' : 'No expenses yet' }, { children: [_jsx(Column, { field: "expenseDate", header: "Date", body: dateTemplate, sortable: true, style: { width: '10%' } }), _jsx(Column, { field: "category.name", header: "Category", body: function (r) { var _a; return _jsx("span", __assign({ className: "mdl-name-cell" }, { children: (_a = r.category) === null || _a === void 0 ? void 0 : _a.name })); }, sortable: true, style: { width: '15%' } }), _jsx(Column, { field: "paidTo", header: "Paid To", style: { width: '12%' } }), _jsx(Column, { field: "narration", header: "Narration", style: { width: '18%' } }), _jsx(Column, { field: "paymentMode", header: "Mode", body: function (r) { var _a; return ((_a = paymentModes.find(function (m) { return m.value === r.paymentMode; })) === null || _a === void 0 ? void 0 : _a.label) || r.paymentMode; }, style: { width: '9%' } }), _jsx(Column, { field: "paymentAccount.accountName", header: "Paid From", style: { width: '12%' } }), _jsx(Column, { field: "amount", header: "Amount", body: amountTemplate, headerClassName: "mdl-col-numeric", bodyClassName: "mdl-col-numeric", sortable: true, style: { width: '10%' } }), _jsx(Column, { field: "status", header: "Status", body: statusTemplate, sortable: true, style: { width: '8%' } }), _jsx(Column, { header: "Actions", body: actionTemplate, headerClassName: "mdl-col-numeric", style: { width: '120px' } })] })), _jsx(Dialog, __assign({ visible: dialogVisible, onHide: function () { return setDialogVisible(false); }, header: "New Expense Entry", style: { width: '550px' }, modal: true }, { children: _jsxs("div", __assign({ className: "p-fluid", style: { display: 'flex', flexDirection: 'column', gap: '1rem', paddingTop: '0.5rem' } }, { children: [_jsxs("div", __assign({ className: "field" }, { children: [_jsx("label", { children: "Date *" }), _jsx(Calendar, { value: newExpense.expenseDate, onChange: function (e) { return setNewExpense(__assign(__assign({}, newExpense), { expenseDate: e.value })); }, dateFormat: "dd/mm/yy", showIcon: true })] })), _jsxs("div", __assign({ className: "field" }, { children: [_jsx("label", { children: "Category *" }), _jsx(Dropdown, { value: newExpense.categoryId, options: categoryOptions, onChange: function (e) { return setNewExpense(__assign(__assign({}, newExpense), { categoryId: e.value })); }, placeholder: "Select Category" })] })), _jsxs("div", __assign({ className: "field" }, { children: [_jsx("label", { children: "Amount (\u20B9) *" }), _jsx(InputNumber, { value: newExpense.amount, onValueChange: function (e) { return setNewExpense(__assign(__assign({}, newExpense), { amount: e.value || 0 })); }, mode: "currency", currency: "INR", locale: "en-IN", minFractionDigits: 2 })] })), _jsxs("div", __assign({ className: "field" }, { children: [_jsx("label", { children: "Paid To" }), _jsx(InputText, { value: newExpense.paidTo, onChange: function (e) { return setNewExpense(__assign(__assign({}, newExpense), { paidTo: e.target.value })); } })] })), _jsxs("div", __assign({ className: "field" }, { children: [_jsx("label", { children: "Payment Mode *" }), _jsx(Dropdown, { value: newExpense.paymentMode, options: paymentModes, onChange: function (e) { return setNewExpense(__assign(__assign({}, newExpense), { paymentMode: e.value })); } })] })), _jsxs("div", __assign({ className: "field" }, { children: [_jsx("label", { children: "Payment Account *" }), _jsx(Dropdown, { value: newExpense.paymentAccountId, options: paymentAccountOptions, onChange: function (e) { return setNewExpense(__assign(__assign({}, newExpense), { paymentAccountId: e.value })); }, placeholder: "Select Account" })] })), newExpense.paymentMode === 'CHEQUE' && (_jsxs("div", __assign({ className: "field" }, { children: [_jsx("label", { children: "Cheque Number" }), _jsx(InputText, { value: newExpense.chequeNumber, onChange: function (e) { return setNewExpense(__assign(__assign({}, newExpense), { chequeNumber: e.target.value })); } })] }))), _jsxs("div", __assign({ className: "field" }, { children: [_jsx("label", { children: "Reference Number" }), _jsx(InputText, { value: newExpense.referenceNumber, onChange: function (e) { return setNewExpense(__assign(__assign({}, newExpense), { referenceNumber: e.target.value })); } })] })), _jsxs("div", __assign({ className: "field" }, { children: [_jsx("label", { children: "Narration" }), _jsx(InputText, { value: newExpense.narration, onChange: function (e) { return setNewExpense(__assign(__assign({}, newExpense), { narration: e.target.value })); } })] })), _jsxs("div", __assign({ style: { display: 'flex', justifyContent: 'flex-end', gap: '0.5rem', marginTop: '0.5rem' } }, { children: [_jsx(Button, { label: "Cancel", className: "p-button-text", onClick: function () { return setDialogVisible(false); } }), _jsx(Button, { label: "Save", icon: "pi pi-check", onClick: handleSave })] }))] })) }))] })));
};
export default Expenses;
